import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationES from "./i18n/es.json";
import translationCA from "./i18n/ca.json";

// the translations
const resources = {
  es: { translation: translationES },
  ca: { translation: translationCA },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "es",
  whitelist: ["es", "ca"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
